import { useEffect, useState } from "react";

const phrases = [
  "Web Developer",
  "Reactjs Developer",
  "JavaScript Enthusiast",
  "Full Stack Developer",
  "AI Developer",
  "Machine Learning Engineer",
  "PHP Developer",
];

export default function Typewriter() {
  const [text, setText] = useState("");
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentPhrase = phrases[phraseIndex];

    let typingSpeed = isDeleting ? 130 : 200;

    const timeout = setTimeout(() => {
      setText(currentPhrase.substring(0, charIndex));

      if (!isDeleting && charIndex < currentPhrase.length) {
        setCharIndex((prev) => prev + 1);
      } else if (isDeleting && charIndex > 0) {
        setCharIndex((prev) => prev - 1);
      } else {
        if (!isDeleting) {
          setIsDeleting(true);
        } else {
          setIsDeleting(false);
          setPhraseIndex((prev) => (prev + 1) % phrases.length);
        }
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, phraseIndex]);

  return (
    <h2 className="typed-text">{text}
      <span className="cursor">|</span>
    </h2>
  );
}
